import useAuth from './useAuth'
import getEnvironmentVariables from '../helpers/getEnvironmentVariables'
import { canManageComms, commsManagerRole } from '../helpers/permissions'

/**
 * Whether the signed-in user may change what gets sent on this host: create,
 * edit or delete a pipeline or template, send or cancel a bulk send, change
 * holidays. As in the old comms app, that needs the comms manager role
 * (comms-tool-dev on dev, comms-tool-prod on production); everyone else
 * gets the same pages read-only.
 *
 * @returns {{canManage: boolean, role: string|null, note: string}} `note` is
 *     the reason shown beside a disabled control, '' when the user may
 */
const useCommsManager = () => {
    const { user } = useAuth()
    const env = getEnvironmentVariables()
    const role = commsManagerRole(env)
    const canManage = canManageComms(user?.permissions, env)
    return {
        canManage,
        role,
        note: canManage ? '' : `Needs the ${role ?? 'comms manager'} role`,
    }
}

export default useCommsManager
